import styles from './styles.less';
import { observer } from 'mobx-react';


function CategoryNav(props) {
    return (
        <ul className={ cx(styles.root, props.className) }>
            { props.children }
        </ul>
    );
}


export default observer(CategoryNav);



// WEBPACK FOOTER //
// ./src/common/components/category-nav/index.js